import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import simpleHash from '@/utils/simpleHash';

/**
 * Get route name and all child route names recursively
 *
 * @param {import('vue-router').RouteConfig} route
 */
function getRouteNames(route) {
  return route.name + route.children?.map(getRouteNames).join();
}
/**
 * Steps routes
 *
 * provides step routes and current step index,
 * calculates previous and next routes for "steps" pages,
 * cancel and update routes for "edit" pages
 * progress route for resuming a draft
 *
 * @param {string} routeName containing the steps routes
 */
export function useStepRoutes(routeName) {
  const router = useRouter();

  /** @type {import('vue-router/types/router').RouteConfigSingleView[]} */
  const stepsRoutes = router.options.routes
    .find(route => route.name === routeName)
    .children.filter(route => !!route.name)
    .filter(route => 'component' in route);

  const stepsHash = simpleHash(stepsRoutes.map(getRouteNames).join());

  return { stepsRoutes, stepsHash };
}

export function useFlowRouteDetails(route) {
  const parentRoute = computed(() => route.matched[route.matched.length - 2]);

  const isCreateRoute = computed(() => route.name?.endsWith('Create'));
  const isEditStepRoute = computed(() => !!route.params.isEditStep);
  const isEditRoute = computed(() => parentRoute.value?.name?.endsWith('Edit'));
  const isStepsRoute = computed(() =>
      route.name?.endsWith('Steps') ||
      parentRoute.value?.name?.endsWith('Steps'));

  return {
    isCreateRoute,
    isEditRoute,
    isEditStepRoute,
    isStepsRoute,
  };
}
